import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Switch from 'components/Switch';

export const DocumentTextContainer = styled.div`
  * {
    margin: revert;
    padding: revert;
    padding-inline-start: revert;
    list-style: revert;
    color: ${ColorPalette.HEX.OuterSpace};
  }

  * > li {
    margin-bottom: 8px;
  }

  * > b {
    font-weight: 600;
  }

  * > blockquote {
    font-style: italic;
  }

  * > h1 {
    font-size: 24px;
  }

  * > h2 {
    font-size: 20px;
  }

  .main-list {
    list-style-type: upper-roman;

    & > li::marker {
      font-size: 20px;
    }
  }

  padding: 12px;
  @media ${({ theme }) => theme.device.mobile} {
    padding: 16px;

    * {
      font-size: 14px;
    }
  }
`;

export const ChooseLanguage = styled(Switch)`
  padding: 2px;

  & > li {
    padding: 8px;

    & > span {
      font-size: 16px;
    }
  }

  @media ${({ theme }) => theme.device.desktop} {
    width: 50%;
  }
`;
